import Form from "../forms/form";
import React from 'react';
import 'animate.css';
import FsBackground from '../../img/first-screen-block.webp';
import FirstScreenSpeacers from "../parts/firsrtscreen-speacers";
import MyCountdown from "../parts/countdown";
import LogoNew from "../../img/she-logo-new.svg";
import FsFon from "../../img/she_fon.jpg";
import DateIcon from "../../img/date-icon.svg"
import PlaceIcon from "../../img/place-icon.svg"
import PeopleIcon from "../../img/people-icon.svg"

import CreativeIndustriesPanels from '../../img/she_in_creative_industries.webp';

function FirstScreen({ fsData }) {

    return (
        fsData ?
            <section id="top" className="relative pt-24 md:pt-28">
                <div className="container max-w-screen-xl mx-auto relative z-30 overflow-hidden px-[15px]">
                    <div className="md:flex md:items-center md:gap-6">

                        <div className="relative">
                            <h1 className="hidden">{fsData.fs_event_name}</h1>
                            <div className="flex justify-center mb-11 md:justify-start lg:mb-8 xl:pl-14">
                                <img src={LogoNew} className="w-60 lg:w-[340px]" alt="Лого SHE Congress"/>
                            </div>
                            <p className="uppercase font-bold text-[28px] text-[#245864] text-center mb-8 md:text-left
                                lg:text-6xl lg:mb-8 xl:pl-14">
                                Рішуча. Справжня. Небайдужа
                            </p>
                            <div className="flex justify-between gap-6 mb-8 md:justify-start md:max-w-[460px] lg:mb-10 xl:pl-14">
                                <div className="flex flex-1 justify-center items-center gap-[10px] md:justify-start md:flex-auto">
                                    <img src={DateIcon} alt="Іконка календаря" className=""/>
                                    <p className="text-base font-medium text-[#245864] lg:text-lg">{fsData.fs_date}</p>
                                </div>

                                <div className="flex flex-1 justify-center items-center gap-[10px] md:justify-start md:flex-auto">
                                    <img src={PlaceIcon} className="" alt="Іконка місця проведення"/>
                                    <p className="text-base font-medium text-[#245864] lg:text-lg">{fsData.fs_place}</p>
                                </div>

                                <div className="flex flex-1 justify-center items-center gap-[10px] md:justify-start md:flex-auto">
                                    <img src={PeopleIcon} className="" alt="Іконка online"/>
                                    <p className="text-base font-medium text-[#245864] lg:text-lg max-sm:leading-none">offline + online</p>
                                </div>

                            </div>

                            {/*<div className="lg:mb-10 xl:pl-14">
                                <p className="text-[#245864] text-3xl font-bold">Івент завершився</p>
                            </div>*/}


                            
                        </div>
                        <div className="bg-white pt-7 px-4 pb-8 xl:pr-11 xl:pt-10 xl:pl-14 xl:pb-10 shadow-[0_4px_20px_rgba(36,88,100,0.12)]">
                            <div className="lg:mb-8">
                                <p className="text-[#245864] text-2xl uppercase text-balance font-bold">Попередня реєстрація на SHE Congress 2026</p>
                            </div>

                            
                                {/*<div className="lg:flex lg:flex-col lg:justify-between">
                                    <div className="mb-6 flex gap-5">
                                        <div className="flex items-center pl-4 pr-2 bg-[#245864] gap-[6px]
                                            font-bold text-white">
                                            <span className="text-3xl">2500</span>
                                            <span className="text-[15px]">грн*</span>
                                        </div>
                                        <div>
                                            <div className="flex items-end gap-[6px] font-bold text-[#245864]">
                                                <span className="relative text-3xl">5000
                                                    <span className="block absolute -left-[8px] top-1/2 -translate-y-1/2
                                                        w-[120%] h-[3px] bg-[#b43125] opacity-80 -rotate-6"></span>
                                                </span>
                                                <span className="text-[15px]">грн*</span>
                                            </div>
                                            <p className="text-[#245864] text-xs font-light">* Ціна до оподаткування</p>
                                        </div>
                                    </div>
                                    <div className="countdown mb-7 lg:mb-0">
                                        <MyCountdown/>
                                    </div>
                                </div>*/}
                                <Form/>
                            </div>

                        {/*<div className="relative w-full md:max-w-[640px]">
                            <img src={CreativeIndustriesPanels} className="w-full h-full" alt="Creative Industries Panels"/>
                        </div>*/}

                    </div>
                </div>

                <div className="absolute top-0 left-0 w-full h-full bg-white opacity-90 z-10 rotate-180" style={{
                    backgroundImage: `url(${FsFon})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                }}/>

                <div className="absolute bottom-0 right-0 w-1/2 h-full z-10" style={{
                    backgroundImage: `url(${FsBackground})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right bottom'
                }}/>
            </section> : ''
    )
}

export default FirstScreen